import { render, staticRenderFns } from "./adminProducts.vue?vue&type=template&id=69568982&"
import script from "./adminProducts.vue?vue&type=script&lang=js&"
export * from "./adminProducts.vue?vue&type=script&lang=js&"
import style0 from "./adminProducts.vue?vue&type=style&index=0&id=69568982&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports